import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/common/Seo";

const NotFound: React.FC = () => {
  return (
    <>
      <Seo
        title="Page not found | Fork"
        description="The page you were looking for does not exist."
        path="/404"
        noIndex
      />

      <div className="flex min-h-screen items-center justify-center bg-dark-base px-5 text-white">
        <div className="max-w-[460px] text-center">
          <Link to="/" aria-label="Fork home" className="inline-flex">
            <img
              src="/assets/fork-logo.png"
              alt="FORK."
              className="h-6 w-auto object-contain"
            />
          </Link>

          <p className="mt-10 text-[10px] font-medium uppercase tracking-[0.16em] text-success">
            Error 404
          </p>
          <h1 className="mt-3.5 text-[clamp(30px,5vw,52px)] font-extrabold leading-[1.04] tracking-[-0.035em]">
            This page doesn't exist
          </h1>
          <p className="mt-4 text-[16px] leading-[1.6] text-dark-textSecondary">
            The link may be out of date, or the page may have moved.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex h-12 items-center rounded-xl bg-accent-bright px-6 text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors hover:bg-accent"
            >
              Back to home
            </Link>
            <Link
              to="/privacy"
              className="inline-flex h-12 items-center rounded-xl border border-white/25 px-6 text-sm font-semibold text-white transition-colors hover:border-white/50"
            >
              Privacy policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
